import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { FORM_SECTION_HEADER_SX, FORM_SECTION_TITLE_SX, FORM_DIVIDER_SX } from "../utils/formModalStyles";

/** Section title inside page forms (onboarding, multi-step). */
const FormSectionHeader = ({ title, sx = {} }) => (
  <Box sx={{ ...FORM_SECTION_HEADER_SX, ...sx }}>
    <Typography sx={FORM_SECTION_TITLE_SX}>{title}</Typography>
    <Divider sx={FORM_DIVIDER_SX} />
  </Box>
);

export default FormSectionHeader;
